let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("2i2PS")).then(() => parcelRequire('278RC'));